import { getPosthogConfig } from "config/api";
import posthog, { PostHogConfig } from "posthog-js";
import { useRef } from "react";

export function usePostHog() {
  const { apiKey, apiHost } = getPosthogConfig();
  const initedRef = useRef(false);

  // Initialize PostHog only once
  const initializePostHog = () => {
    if (initedRef.current) return;
    if (!apiKey || !apiHost) return;

    posthog.init(apiKey, {
      api_host: apiHost,
      autocapture: true, // Enable automatic tracking of button clicks, form submissions, etc.
      capture_pageview: "history_change" as any,
      capture_pageleave: "if_capture_pageview",
      defaults: "2025-05-24", // Use latest defaults as of this date
      session_recording: {
        maskTextSelector: ".sensitive",
        blockSelector: ".sensitive",
        blockClass: "sensitive",
        maskInputFn: (text, element) => {
          if (
            element?.getAttribute("id") === "firstName" ||
            element?.getAttribute("id") === "lastName" ||
            element?.getAttribute("id") === "email" ||
            element?.getAttribute("id") === "dateOfBirth" ||
            element?.getAttribute("id") === "phoneNumber" ||
            element?.getAttribute("id") === "patientSearch" ||
            element?.getAttribute("id") === "code" ||
            element?.getAttribute("id") === "patientAccountNumber"
          ) {
            return "*".repeat(text.length);
          }
          return text;
        },
      },
    } as Partial<PostHogConfig>);
    initedRef.current = true;
  };

  // Track custom events
  const posthogEvent = (event: string, properties?: object) => {
    posthog.capture(event, properties);
  };

  // Track page view events with custom properties (e.g., account name, order type, etc.)
  const pageViewEvents = (
    {
      accountName,
      orderType,
      communicationMethod,
    }: {
      [key: string]: string | undefined;
    },
    event: string
  ) => {
    posthog.capture(event, {
      accountName,
      orderType,
      communicationMethod,
    });
  };

  return {
    posthogEvent,
    pageViewEvents,
    initializePostHog,
  };
}
